import React from 'react';
import { graphql } from 'gatsby';
import Layout from 'components/Layout';
import SEO from 'components/SEO';
import Hero from 'components/Hero';
import Tout from 'components/Tout';
import ContactForm from 'components/ContactForm';
import SliceZone from 'components/SliceZone';

export default ({ data }) => {
  const landing = data.prismic.landingByUID;
  const allProducts = data.prismic.allProductss.edges[0].node;
  const site = data.prismic.allSite_settingss.edges[0].node;

  if (!landing) {
    return null;
  }

  const flushSlices = ['form','product_suite','accordion'];

  return (
    <Layout
      hideHeader={!landing.header_display}
      hideFooter={!landing.footer_display}
    >
      <SEO
        title={landing.social_title || landing.hero_heading || 'SEM Landing'}
        description={
          landing.social_description ? landing.social_description : null
        }
        image={landing.social_image ? landing.social_image.url : null}
        noFollow={landing.no_follow}
        hideChat={!landing.chat_display}
      />

      {((landing.hero_intro && landing.hero_intro.length > 0) || (landing.hero_heading && landing.hero_heading.length > 0) || (landing.hero_content && landing.hero_content[0] && ((landing.hero_content[0].text && landing.hero_content[0].text.length > 0) || landing.hero_content[0].url))) && (
        <Hero
          rubric={landing.hero_intro}
          heading={landing.hero_heading}
          content={landing.hero_content}
          image={landing.hero_image}
          illustration={landing.hero_illustration}
        />
      )}

      {landing.tout_heading && (
        <Tout
          intro={landing.tout_intro}
          heading={landing.tout_heading}
          content={landing.tout_content}
        />
      )}

      {landing.form_handler && (
        <ContactForm
          heading={landing.form_heading || 'Get In Touch'}
          buttonText={landing.form_button_text || 'Get In Touch'}
          handler={landing.form_handler}
          category={landing._meta.uid}
          thankYou={landing.form_thank_you_text || site.default_thank_you_text}
        />
      )}

      {landing.body &&
      <SliceZone
        body={landing.body}
        allProducts={allProducts}
        variant='landing'
        uid={landing._meta.uid}
        settings={site}
        hasForm={landing.form_handler}
        bottomSpacer={landing.body && landing.body.length > 0 && !flushSlices.includes(landing.body[landing.body.length - 1].type)}
      />
      }
    </Layout>
  );
};

export const query = graphql`
    query getLanding($uid: String!) {
        prismic {
            landingByUID: landing(uid: $uid, lang: "en-us") {
                _meta {
                    uid
                }
                footer_display
                header_display
                chat_display
                hero_intro
                hero_heading
                hero_content
                hero_image
                hero_illustration {
                    ... on PRISMIC__FileLink {
                        _linkType
                        name
                        size
                        url
                    }
                }
                tout_intro
                tout_heading
                tout_content
                form_heading
                form_button_text
                form_handler
                form_thank_you_text
                social_title
                social_description
                social_image
                no_follow
                body {
                    ... on PRISMIC_LandingBodyTout {
                        type
                        primary {
                            content
                            heading
                            intro
                        }
                    }
                    ... on PRISMIC_LandingBodyContent_block {
                        type
                        primary {
                            content
                            heading
                            intro
                            image
                            illustration {
                                ... on PRISMIC__FileLink {
                                    _linkType
                                    url
                                }
                            }
                        }
                    }
                    ... on PRISMIC_LandingBodyContent_columns {
                        type
                        fields {
                            content
                            heading
                            image
                        }
                    }
                    ... on PRISMIC_LandingBodyAccordion {
                        type
                        fields {
                            content
                            heading
                            illustration {
                                ... on PRISMIC__FileLink {
                                    _linkType
                                    url
                                }
                            }
                            image
                        }
                        primary {
                            content
                            heading
                            illustration {
                                ... on PRISMIC__FileLink {
                                    _linkType
                                    url
                                }
                            }
                            image
                            intro
                        }
                    }
                    ... on PRISMIC_LandingBodyContent_list {
                        type
                        fields {
                            additional_content
                            content
                            heading
                            illustration {
                                ... on PRISMIC__FileLink {
                                    _linkType
                                    url
                                }
                            }
                            image
                        }
                        primary {
                            content
                            heading
                            illustration {
                                ... on PRISMIC__FileLink {
                                    _linkType
                                    url
                                }
                            }
                            image
                            intro
                            is_numbered
                        }
                    }
                    ... on PRISMIC_LandingBodyCase_study {
                        type
                        primary {
                            case_study_delay
                        }
                        fields {
                            study {
                                ... on PRISMIC_Case_study {
                                    company
                                    logo
                                    quote
                                    content
                                    image
                                    statistics {
                                        label
                                        value
                                    }
                                }
                            }
                        }
                    }
                    ... on PRISMIC_LandingBodyTrapdoor {
                        type
                        primary {
                            button_text
                            destination
                            is_external
                            heading
                            intro
                        }
                    }
                    ... on PRISMIC_LandingBodyProduct_suite {
                        type
                        primary {
                            heading
                            content
                        }
                    }
                    ... on PRISMIC_LandingBodyPlayer {
                        type
                        primary {
                            widget_name
                            pubname
                            plid
                        }
                    }
                    ... on PRISMIC_LandingBodyCustom_html {
                        type
                        primary {
                            content
                        }
                    }
                    ... on PRISMIC_LandingBodyForm {
                        type
                        primary {
                            heading
                            button_text
                            handler
                            thank_you_text
                            background
                            content
                        }
                    }
                }
            }
            allProductss {
                edges {
                    node {
                        heading
                        content
                        products_list {
                            product {
                                ... on PRISMIC_Product {
                                    logo
                                    name
                                    logline
                                    short_description
                                    preview_image
                                    preview_hover_image
                                    _meta {
                                        uid
                                    }
                                }
                            }
                        }
                        case_study_delay
                    }
                }
            }
            allSite_settingss {
                edges {
                    node {
                        default_thank_you_text
                    }
                }
            }
        }
    }
`;
